var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHomeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none",
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M14.155 19.997H5.844a3.57 3.57 0 0 1-3.699-3.399v-4.455a.714.714 0 1 1 1.428 0v4.455a2.142 2.142 0 0 0 2.27 1.971h8.312a2.142 2.142 0 0 0 2.27-1.97v-4.456a.714.714 0 1 1 1.429 0v4.455a3.57 3.57 0 0 1-3.699 3.4Zm5.634-9.49a.716.716 0 0 0 0-1.013L10.506.21a.715.715 0 0 0-1.014 0L.21 9.494a.717.717 0 0 0 1.014 1.014l8.775-8.783 8.776 8.783a.714.714 0 0 0 1.014 0Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeIcon);
export default __webpack_public_path__ + "static/media/home-icon.31e5fb6de6c0e32c6d2439bb95f56ba3.svg";
export { ForwardRef as ReactComponent };